import script from "./AUDIT_COMMENT_DELETE_TASK_CHANGED.vue?vue&type=script&setup=true&lang=ts"
export * from "./AUDIT_COMMENT_DELETE_TASK_CHANGED.vue?vue&type=script&setup=true&lang=ts"

import "./AUDIT_COMMENT_DELETE_TASK_CHANGED.vue?vue&type=style&index=0&id=d6c47b86&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6c47b86"]])

export default __exports__